import { defineMessages } from 'react-intl';

export default defineMessages({
    confirmationToRemoveTitle: {
        id: 'service.directives.ServiceDocuments.Remove Document',
        defaultMessage: 'Remove Document'
    },
    confirmationToRemoveMessage: {
        id: 'service.directives.ServiceDocuments.Are you sure you want to remove',
        defaultMessage: 'Are you sure you want to remove {documentname}?'
    },
    removeConfirmationYes: {
        id: 'service.directives.ServiceDocuments.Yes',
        defaultMessage: 'Yes'
    },
    removeConfirmationNo: {
        id: 'service.directives.ServiceDocuments.No',
        defaultMessage: 'No'
    },
    removeServiceFailedTitle: {
        id: 'service.directives.ServiceDocuments.Document deletion failed',
        defaultMessage: 'Document deletion failed'
    },
    removeServiceFailedMessage: {
        id: 'service.directives.ServiceDocuments.Sorry your document could not be deleted at this time',
        defaultMessage: 'Sorry your document could not be deleted at this time'
    }
});
